import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import notiSlice from "./slices/notiSlice";
import profileSlice from "./slices/profileSlice";


export default configureStore({
  reducer: {
    auth: authSlice,
    profile: profileSlice,
    noti: notiSlice,
  },
});
